import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cardUM',
  templateUrl: './cardUM.component.html',
  styleUrls: ['./cardUM.component.css']
})
export class CardUMComponent implements OnInit {

  @Input()num:string="";
  constructor() { }

  ngOnInit() {
  }

}
